import React from "react";
import { VStack } from "@chakra-ui/react";
import { UserResponse } from "../UserResponse";
import {
  ListeningQuestionData,
  ListeningQuestionType,
} from "../../../../../types/listening-types";
import { MockQuestion } from "../../../../../types/reading-types";

type ListeningForInformationResponseProps = {
  questionData: ListeningQuestionData;
  stage: number;
};

export const ListeningForInformationUserResponse: React.FC<
  ListeningForInformationResponseProps
> = ({ questionData, stage }) => {
  const renderUserResponse = (index: number) => {
    return (
      <>
        {index === 3 && (
          <UserResponse
            questions={questionData.questions[0] as MockQuestion}
            questionType={questionData.questionsType as ListeningQuestionType}
          />
        )}
        {index === 4 && (
          <UserResponse
            questions={questionData.questions[1] as MockQuestion}
            questionType={questionData.questionsType as ListeningQuestionType}
          />
        )}
        {index === 5 && (
          <UserResponse
            questions={questionData.questions[2] as MockQuestion}
            questionType={questionData.questionsType as ListeningQuestionType}
          />
        )}
        {index === 6 && (
          <UserResponse
            questions={questionData.questions[3] as MockQuestion}
            questionType={questionData.questionsType as ListeningQuestionType}
          />
        )}
        {index === 7 && (
          <UserResponse
            questions={questionData.questions[4] as MockQuestion}
            questionType={questionData.questionsType as ListeningQuestionType}
          />
        )}
        {index === 8 && (
          <UserResponse
            questions={questionData.questions[5] as MockQuestion}
            questionType={questionData.questionsType as ListeningQuestionType}
          />
        )}
      </>
    );
  };

  if (
    stage === 3 ||
    stage === 4 ||
    stage === 5 ||
    stage === 6 ||
    stage === 7 ||
    stage === 8
  ) {
    return (
      <VStack
        align="start"
        spacing={5}
        w="full"
        p={3}
        bg="surface.low"
        minH="90vh"
        maxH="90vh"
        borderBottom="1px #CCC solid"
        ml={-2}
        overflowY="auto"
      >
        {renderUserResponse(stage)}
      </VStack>
    );
  }

  return null;
};
